// extracted by mini-css-extract-plugin
export default {"componentLabel":"styles_componentLabel__Ybc8z","dailyFlex":"styles_dailyFlex__ZCAkp","dailyBox":"styles_dailyBox__wAVQy"};